<template>
  <div
    class="table-cell table-cell-category"
    :class="classes"
    :title="description"
  >
    {{ questionValue }}
  </div>
</template>

<script>
export default {
  name: 'PulsTableQuestionCell',
  props: {
    group: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    result: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: null
    },
    percentageString: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    }
  },
  computed: {
    questionValue() {
      //check if number, otherwise display as is

      //check if value is a number
      if (this.percentageString) {
        return this.percentageString
      } else {
        return this.$localeNumber(this.value, 1)
      }
    },
    classes() {
      const fontSize = this.percentageString ? 'fs-8' : 'fs-7'
      return `${this.result} ${fontSize}`
    }
  }
}
</script>
